import LangEnum from '../../../../lang/LangEnum';
import filterOptionsRepository from '../../../../services/modules/filterOptions/repositories/filterOptions.repository';
import CatalogBatchAddEntityModal from './CatalogBatchAddEntityModal';

interface CatalogBatchAddClassificationsModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (ids: string[]) => void;
}

const repository = filterOptionsRepository();

const CatalogBatchAddClassificationsModal = ({
  open,
  onClose,
  onConfirm,
}: CatalogBatchAddClassificationsModalProps) => (
  <CatalogBatchAddEntityModal<{ id: string; name: string }>
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    queryKeyBase="catalog-batch-add-classifications"
    fetchFn={repository.findCatalogAccessClassifications}
    searchParam="query"
    defaultOrderBy={{ name: 'ASC' as const }}
    titleKey={LangEnum.CATALOGS_BULK_ADD_CLASSIFICATIONS_MODAL_TITLE}
    descriptionKey={LangEnum.CATALOGS_BULK_ADD_CLASSIFICATIONS_MODAL_DESCRIPTION}
    searchEntityKey={LangEnum.GLOBAL_CUSTOMERS_CLASSIFICATIONS}
    getOptionLabel={(option) => option.name}
  />
);

export default CatalogBatchAddClassificationsModal;
